module.exports = __webpack_public_path__ + "img/icon-info.82917ac0.svg";